<template>
    <div class="flex flex-row gap-3 sticky -top-6 bg-white py-6 z-10 -mt-6 border-b">
        <div class="flex flex-col items-center px-4 py-2 w-full border rounded-md border-blue-200 bg-blue-50 text-blue-500">
            <p class="text-sm mb-0">Digital Input 1</p>
            <span class="font-bold">{{ digitalInputOne }}</span>
        </div>
        <div class="flex flex-col items-center px-4 py-2 w-full border rounded-md border-orange-200 bg-orange-50 text-orange-400">
            <p class="text-sm mb-0">Digital Input 2</p>
            <span class="font-bold">{{ digitalInputTwo }}</span>
        </div>
    </div>

    <div class="mt-8 flex flex-col items-start">
        <div class="flex gap-3 items-center w-full py-2">
            <h1 class="text-lg mb-0 p-0">Digital Input 1</h1>
            <button class="px-6 py-1 border border-blue-300 text-blue-600 rounded-md font-normal hover:bg-blue-50 active:bg-blue-100"
                    @click="sendToParameterValueInput(inputOne, digitalInputOne)"
            >
                Send To Parameter Value Input
            </button>
        </div>

        <div class="grid grid-cols-2 gap-2 w-full">
            <button class="w-full px-8 py-3 rounded-md text-white bg-blue-400 hover:bg-blue-500 active:bg-blue-600"
                    @click="handlersDI1.enableAll"
            >
                Enable All
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-blue-400 hover:bg-blue-500 active:bg-blue-600"
                    @click="handlersDI1.disableAll"
            >
                Disable All
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-blue-400 hover:bg-blue-500 active:bg-blue-600"
                    @click="handlersDI1.allHighOpen"
            >
                All High = Open
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-blue-400 hover:bg-blue-500 active:bg-blue-600"
                    @click="handlersDI1.allLowOpen"
            >
                All Low = Closed
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-blue-400 hover:bg-blue-500 active:bg-blue-600"
                    @click="handlersDI1.alarmingOn"
            >
                All Alarming On
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-blue-400 hover:bg-blue-500 active:bg-blue-600"
                    @click="handlersDI1.alarmingOff"
            >
                All Alarming Off
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-blue-400 hover:bg-blue-500 active:bg-blue-600"
                    @click="handlersDI1.alarmOnOpen"
            >
                All Alarm On Open
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-blue-400 hover:bg-blue-500 active:bg-blue-600"
                    @click="handlersDI1.alarmOnClosed"
            >
                All Alarm On Closed
            </button>
        </div>

        <div class="flex flex-col w-full mt-4 gap-2">
            <channel
                v-for="(channel, index) in channelsOne"
                :key="index"
                :channel="index + 1"
                v-model="channel.enabled"
                :high-is-open="channel.highIsOpen"
                :alarms-enabled="channel.alarmsEnabled"
                :alarm-on-open="channel.alarmOnOpen"
                @update:highIsOpen="val => channel.highIsOpen = val"
                @update:alarmsEnabled="val => channel.alarmsEnabled = val"
                @update:alarmTrigger="val => channel.alarmOnOpen = val"
            />
        </div>
    </div>

    <div class="mt-8 flex flex-col items-start">
        <div class="flex gap-3 items-center w-full py-2">
            <h1 class="text-lg mb-0 p-0">Digital Input 2</h1>
            <button class="px-6 py-1 border border-orange-200 text-orange-500 rounded-md font-normal hover:bg-orange-50 active:bg-orange-100"
                    @click="sendToParameterValueInput(inputTwo, digitalInputTwo)"
            >
                Send To Parameter Value Input
            </button>
        </div>

        <div class="grid grid-cols-2 gap-2 w-full">
            <button class="w-full px-8 py-3 rounded-md text-white bg-orange-300 hover:bg-orange-400 active:bg-orange-500"
                    @click="handlersDI2.enableAll"
            >
                Enable All
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-orange-300 hover:bg-orange-400 active:bg-orange-500"
                    @click="handlersDI2.disableAll"
            >
                Disable All
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-orange-300 hover:bg-orange-400 active:bg-orange-500"
                    @click="handlersDI2.allHighOpen"
            >
                All High = Open
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-orange-300 hover:bg-orange-400 active:bg-orange-500"
                    @click="handlersDI2.allLowOpen"
            >
                All Low = Closed
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-orange-300 hover:bg-orange-400 active:bg-orange-500"
                    @click="handlersDI2.alarmingOn"
            >
                All Alarming On
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-orange-300 hover:bg-orange-400 active:bg-orange-500"
                    @click="handlersDI2.alarmingOff"
            >
                All Alarming Off
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-orange-300 hover:bg-orange-400 active:bg-orange-500"
                    @click="handlersDI2.alarmOnOpen"
            >
                All Alarm On Open
            </button>
            <button class="w-full px-8 py-3 rounded-md text-white bg-orange-300 hover:bg-orange-400 active:bg-orange-500"
                    @click="handlersDI2.alarmOnClosed"
            >
                All Alarm On Closed
            </button>
        </div>
    </div>

    <div class="flex flex-col w-full mt-4 gap-2">
        <channel
            v-for="(channel, index) in channelsTwo"
            :key="index"
            :channel="index + 1"
            alternate-colors
            v-model="channel.enabled"
            :high-is-open="channel.highIsOpen"
            :alarms-enabled="channel.alarmsEnabled"
            :alarm-on-open="channel.alarmOnOpen"
            @update:highIsOpen="val => channel.highIsOpen = val"
            @update:alarmsEnabled="val => channel.alarmsEnabled = val"
            @update:alarmTrigger="val => channel.alarmOnOpen = val"
        />
    </div>

</template>

<script setup>
import Channel from "@/components/DuoPlusCCICalculator/Channel.vue";
import {ref, watch, onMounted} from "vue";

const props = defineProps({
    inputOne: {
        type: Object
    },
    inputTwo: {
        type: Object
    }
});

const digitalInputOne = ref('00000000');
const digitalInputTwo = ref('00000000');

onMounted(() => {
    const elementInputOne = document.querySelector(`input[name='${props.inputOne?.number}']`);
    if (elementInputOne?.value && /^[\da-fA-F]{8}$/.test(elementInputOne.value)) {
        digitalInputOne.value = elementInputOne.value;
    }

    const elementInputTwo = document.querySelector(`input[name='${props.inputTwo?.number}']`);
    if (elementInputTwo?.value && /^[\da-fA-F]{8}$/.test(elementInputTwo.value)) {
        digitalInputTwo.value = elementInputTwo.value;
    }
});

const defaultChannelState = () => ({
    enabled: false,
    highIsOpen: false,
    alarmsEnabled: false,
    alarmOnOpen: false,
});

const channelsOne = ref(Array.from({ length: 8 }, defaultChannelState));
const channelsTwo = ref(Array.from({ length: 8 }, defaultChannelState));

function toHexBitmask(channels) {
    const bytes = [0, 0, 0, 0];

    channels.forEach((ch, index) => {
        const bit = 1 << index;
        if (ch.enabled)         bytes[0] |= bit;
        if (ch.highIsOpen)      bytes[1] |= bit;
        if (ch.alarmsEnabled)   bytes[2] |= bit;
        if (ch.alarmOnOpen)     bytes[3] |= bit;
    });

    return bytes.map(b => b.toString(16).padStart(2, '0')).join('').toUpperCase();
}

function fromHexBitmask(hex, channels) {
    if (!/^[\da-fA-F]{8}$/.test(hex)) {
        console.error('Invalid hex input:', hex);
        return;
    }

    const bytes = hex.match(/.{1,2}/g)?.map(h => parseInt(h, 16)) ?? [0, 0, 0, 0];

    channels.forEach((ch, index) => {
        const bit = 1 << index;
        ch.enabled       = (bytes[0] & bit) !== 0;
        ch.highIsOpen    = (bytes[1] & bit) !== 0;
        ch.alarmsEnabled = (bytes[2] & bit) !== 0;
        ch.alarmOnOpen   = (bytes[3] & bit) !== 0;
    });
}

watch(channelsOne, () => {
    digitalInputOne.value = toHexBitmask(channelsOne.value);
}, { deep: true });

watch(channelsTwo, () => {
    digitalInputTwo.value = toHexBitmask(channelsTwo.value);
}, { deep: true });

watch(digitalInputOne, (newVal) => {
    fromHexBitmask(newVal, channelsOne.value);
});

watch(digitalInputTwo, (newVal) => {
    fromHexBitmask(newVal, channelsTwo.value);
});

function sendToParameterValueInput(input, value) {
    const target = document.getElementsByName(input.number)

    if (target && target.length === 1) {
        if (target[0].value === value) return;
        target[0].value = value;
        input.value = value;
    }
}

function setAll(channels, key, value) {
    channels.forEach(c => c[key] = value);
}

function setAllHandlersForDI1() {
    return {
        enableAll: () => setAll(channelsOne.value, 'enabled', true),
        disableAll: () => setAll(channelsOne.value, 'enabled', false),
        allHighOpen: () => setAll(channelsOne.value, 'highIsOpen', true),
        allLowOpen: () => setAll(channelsOne.value, 'highIsOpen', false),
        alarmingOn: () => setAll(channelsOne.value, 'alarmsEnabled', true),
        alarmingOff: () => setAll(channelsOne.value, 'alarmsEnabled', false),
        alarmOnOpen: () => setAll(channelsOne.value, 'alarmOnOpen', true),
        alarmOnClosed: () => setAll(channelsOne.value, 'alarmOnOpen', false),
    };
}

function setAllHandlersForDI2() {
    return {
        enableAll: () => setAll(channelsTwo.value, 'enabled', true),
        disableAll: () => setAll(channelsTwo.value, 'enabled', false),
        allHighOpen: () => setAll(channelsTwo.value, 'highIsOpen', true),
        allLowOpen: () => setAll(channelsTwo.value, 'highIsOpen', false),
        alarmingOn: () => setAll(channelsTwo.value, 'alarmsEnabled', true),
        alarmingOff: () => setAll(channelsTwo.value, 'alarmsEnabled', false),
        alarmOnOpen: () => setAll(channelsTwo.value, 'alarmOnOpen', true),
        alarmOnClosed: () => setAll(channelsTwo.value, 'alarmOnOpen', false),
    };
}

const handlersDI1 = setAllHandlersForDI1();
const handlersDI2 = setAllHandlersForDI2();

</script>